var map = {
	"./Catch.mp3": 2852,
	"./Dungeon common.mp3": 18266,
	"./Dungeon.mp3": 77779,
	"./Fight dark.mp3": 86477,
	"./Fight epic.mp3": 42822,
	"./Fight low.mp3": 61301,
	"./Fight low2.mp3": 38845,
	"./Fight newtwo.mp3": 83213,
	"./Fight normal.mp3": 59844,
	"./Fight waitin for.mp3": 42742,
	"./Fight.mp3": 37767,
	"./InfernoTown.mp3": 51792,
	"./League lost.mp3": 27834,
	"./League start.mp3": 57548,
	"./League win.mp3": 97778,
	"./Legend.mp3": 50988,
	"./Pohoda cesta.mp3": 63356,
	"./Pohoda cirkus.mp3": 6996,
	"./Pohoda deprese.mp3": 16914,
	"./Pohoda kolo.mp3": 89179,
	"./Pohoda louka.mp3": 7646,
	"./Pohoda pianko.mp3": 368,
	"./Pohoda plaz.mp3": 92259,
	"./Pohoda route 29.mp3": 91608,
	"./Pohoda surfing.mp3": 89378,
	"./Pohoda vesnice.mp3": 79423,
	"./Pohoda voda.mp3": 59246,
	"./Problems.mp3": 88771,
	"./RAMPART.mp3": 13986,
	"./Ruins.mp3": 38228,
	"./Stadion trainer win.mp3": 30252,
	"./Start.mp3": 25697,
	"./Team Rocket.mp3": 66332,
	"./Wild trainer win.mp3": 1790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3958;